module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isReady) ? _c('div', {
    staticClass: "site-main"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('pic-swipe', {
    attrs: {
      "items": _vm.items
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "conference"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('ul', {
    staticClass: "columns"
  }, [(!_vm.isMobile) ? _vm._l((_vm.ConfNum1), function(obj, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-two-thirds-tablet is-half-desktop first-conf"
    }, [_c('div', {
      staticClass: "hover-a",
      class: {
        'transparent': !_vm.displayHover
      }
    }, [_c('div', {
      staticClass: "shadow",
      class: {
        'shadowCursor': !_vm.displayHover
      },
      on: {
        "click": function($event) {
          _vm.location(obj.urllink)
        }
      }
    }, [(_vm.displayHover) ? _c('div', {
      staticClass: "content-a"
    }, [_c('a', {
      staticClass: "left",
      attrs: {
        "href": obj.urllink,
        "target": "_blank"
      }
    }, [_c('p', {
      staticClass: "geekbang-icon"
    }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("查看大会")])]), _vm._v(" "), _vm._m(2, true, false)]) : _vm._e()])])])
  }) : _vm._l((_vm.ConfNum1), function(obj, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-two-thirds-tablet is-half-desktop"
    }, [_c('a', {
      attrs: {
        "href": obj.urllink,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": obj.m_imgUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "hover-a"
    }, [(_vm.displayHover) ? _c('div', {
      staticClass: "content-a"
    }, [_c('a', {
      staticClass: "left",
      attrs: {
        "href": obj.urllink,
        "target": "_blank"
      }
    }, [_c('p', {
      staticClass: "geekbang-icon"
    }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("查看大会")])]), _vm._v(" "), _vm._m(3, true, false)]) : _vm._e()])])])
  }), _vm._v(" "), _vm._l((_vm.filterConf), function(obj, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-third-tablet is-one-quarter-desktop"
    }, [_c('a', {
      attrs: {
        "href": obj.urllink,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      ref: "m_confImg",
      refInFor: true,
      attrs: {
        "src": obj.imgUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('strong', [_vm._v(_vm._s(obj.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(obj.dateAndLoc))])])])])
  })], 2)])]), _vm._v(" "), _c('card-columns'), _vm._v(" "), _c('div', {
    staticClass: "member"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "parentBox"
  }, [_c('ul', {
    staticClass: "columns is-mobile childBox"
  }, _vm._l((_vm.members), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-third-tablet is-one-quarter-desktop"
    }, [_c('a', [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "company"
    }, [_vm._v(_vm._s(item.company))]), _vm._v(" "), _c('div', {
      staticClass: "profile"
    }, [_vm._v(_vm._s(item.profile))]), _vm._v(" "), _c('p', {
      staticClass: "brief"
    }, [_vm._v(_vm._s(item.brief))])])])])
  }))])])]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(5, false, false), _vm._v(" "), _c('ul', {
    staticClass: "columns"
  }, _vm._l((_vm.videos), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-half-tablet is-one-third-desktop"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.displayVideo(item.videoUrl)
        }
      }
    }, [_c('div', {
      staticClass: "video-img"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "a"
    })]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_c('strong', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.writer))])])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(6, false, false), _vm._v(" "), _c('ul', {
    staticClass: "columns"
  }, _vm._l((_vm.videos), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-half-tablet is-one-third-desktop"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'video',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "video-img"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "a"
    })]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_c('strong', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.writer))])])])], 1)
  }))])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "isShow": _vm.isShowVideo,
      "videolink": _vm.videoUrl
    },
    on: {
      "closeModal": _vm.toclose
    }
  })], 1) : _c('com-loader')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns bannerInfo is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-half-tablet is-one-quarter-desktop"
  }, [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzU1NDA4NjU2MA==&mid=2247486710&idx=4&sn=f909fe34e7c23e9f969412129db89229&chksm=fbe9b539cc9e3c2f4a1557ac1c8b360c4ff8fcbe00cfa7feece36f53bddb4fe005fff1372ba4#rd",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bannerInfo/tencent@3x.png")
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("AI前线")]), _vm._v(" "), _c('span', [_vm._v("紧跟前沿的AI技术社群")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile is-half-tablet is-one-quarter-desktop"
  }, [_c('a', {
    attrs: {
      "href": "http://www.infoq.com/cn/minibooks/architect-201707",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bannerInfo/tech@3x.png")
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("《架构师》")]), _vm._v(" "), _c('span', [_vm._v("一本属于架构师的电子杂志")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile is-half-tablet is-one-quarter-desktop"
  }, [_c('a', {
    attrs: {
      "href": "https://h5.youzan.com/v2/showcase/homepage?kdt_id=18601096&reft=1500973516574_1500973570771&spm=f46413509",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bannerInfo/geekroom@3x.png")
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("极客官舍")]), _vm._v(" "), _c('span', [_vm._v("为极致和美好付费")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile is-half-tablet is-one-quarter-desktop"
  }, [_c('a', {
    attrs: {
      "href": "/events",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bannerInfo/dream@3x.png")
    }
  }), _vm._v(" "), _c('p', [_c('strong', [_vm._v("活动大本营")]), _vm._v(" "), _c('span', [_vm._v("一周精彩技术活动")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("大会")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right",
    attrs: {
      "href": "//live.geekbang.org/room/btree",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "geekbang-icon"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("观看直播")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right",
    attrs: {
      "href": "//live.geekbang.org",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "geekbang-icon"
  }, [_vm._v("")]), _vm._v(" "), _c('p', [_vm._v("观看视频")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("会员")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "href": "http://ego.geekbang.org/member",
      "target": "_blank"
    }
  }, [_vm._v("查看更多>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("视频")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "href": "https://live.geekbang.org/video",
      "target": "_blank"
    }
  }, [_vm._v("查看更多>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("视频")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d9c3fcf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 455
// module chunks = 1